import {CanActivateFn, Router} from '@angular/router';
import {FeatureKey} from "@common-module/modelinterfaces/enums/feature-key";
import {inject} from "@angular/core";
import {PermissionsSecurityService} from "../services/permissions-security.service";
import {catchError, filter, map} from "rxjs/operators";
import {of} from "rxjs";

export function permissionGuard(key: FeatureKey, redirectPath: string = '/access-denied'): CanActivateFn  {
  return () => {
    const permissionSecurityService: PermissionsSecurityService = inject(PermissionsSecurityService);
    const router: Router = inject(Router);

    return permissionSecurityService.isPermissionsReadyObservable$.pipe(
      filter(value => !!value),
      map((value) => {
        const isAllowed: boolean = permissionSecurityService.isAllowed(key);
        return isAllowed || router.createUrlTree([redirectPath]);
      }),
      catchError(() => of(false)),
    )

  }
}
